import { render, staticRenderFns } from "./CardConfirmacaoCancelamento.vue?vue&type=template&id=728444a1&scoped=true&"
import script from "./CardConfirmacaoCancelamento.vue?vue&type=script&lang=js&"
export * from "./CardConfirmacaoCancelamento.vue?vue&type=script&lang=js&"
import style0 from "./CardConfirmacaoCancelamento.vue?vue&type=style&index=0&id=728444a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728444a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
